import React from "react";

// Create the context
export const MenuContext = React.createContext<
  [boolean, React.Dispatch<React.SetStateAction<boolean>>]
>([false, () => {}]);

interface MenuProviderProps {
  children: React.ReactNode;
}

export function MenuProvider({ children }: MenuProviderProps) {
  // Place state in here
  const [isOpen, setNav] = React.useState(false);

  return (
    <MenuContext.Provider value={[isOpen, setNav]}>
      {children}
    </MenuContext.Provider>
  );
}

export default MenuContext;
